import FileExplorer from '../../components/fileExplorer/FileExplorer';
import SearchBar from '../../components/common/SearchBar';
import Sidebar from '../../components/sidebar/Sidebar';
import NavBar from '../../components/navbar/NavBar';
import { config } from '../../config/Constants';
import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import Cookies from 'js-cookie';
import Axios from 'axios';
import './remit.css';
import { getSelectData } from '../../utils/api/data';
import { getDynamicSelectData } from '../../utils/api/data';

const Remit = () => {
  const [searchValue, setSearchValue] = useState('');
  const searchConfig = { size: 'normal', keyPress: true }

  const [blobObject, setBlobObject] = useState({
    blobContainer: 'remit-archive',
    fileData: {},
    fileExplorerAttribute :{
      fileHeaders: ['File Name', 'Modified Date', 'Created Date', 'Action'],
      fileButtons: ['Remit Download']
    },
  });

  const getCompany = () => { return Cookies.get('cp-cn'); }

  const fetchData = async() => {
    const responseSelect = await getSelectData({
      selectValues: '"FILE_NAME", "LAST_MODIFIED_DATE", "INSERT_DATE_TIME"', tableName: 'REPORT.REMIT_FILES ',
      whereField: 'CUSTOMER_NAME', whereValue: Cookies.get('cp-cn'), db: 'SF'
    });
    setBlobObject(prevState => ({
      ...prevState,
      fileData: {
        ...prevState.fileData,
        fileObject: responseSelect
      }
    }));
  }

  useEffect(() => { 
    fetchData(); 
  }, []);

  const searchRemit = async() => {
    const responseSelect = await getDynamicSelectData({
      selectValues: '"FILE_NAME", "LAST_MODIFIED_DATE", "INSERT_DATE_TIME"', 
      tableName: 'REPORT.REMIT_FILES ',
      whereField: ['FILE_NAME', "CUSTOMER_NAME"], 
      whereOperators:["LIKE", "="], 
      whereValue: [searchValue, Cookies.get('cp-cn')], 
      db: 'SF'
    });
    return responseSelect;
  }

  const handleRemitSearch = async() => {
    const companyName = getCompany();
    const response = await searchRemit(companyName);

    setBlobObject(prevState => ({
      ...prevState,
      fileData: {
        ...prevState.fileData,
        fileObject: response
      }
    }));
  }

  const inputValue = (value) => { setSearchValue(value); }

  return (
  <div className='LandingPage'>
    <div className="LandingPageContainer">
      <NavBar/>
      <Sidebar/>
      <div className="LandingPageContent">
        <div className="LandingPageContentTop">
          <div className="remitTitle">
              <h1>Remit Download</h1>
          </div>
          <div className="remitSearch">
            <div className="remitSearchBar">
              <SearchBar inputValue={inputValue} config={searchConfig}/>
            </div>
            <div className="remitSearchButton">
              <Button variant='outlined' onClick={() => handleRemitSearch()}>Search</Button>
            </div>
          </div>
        </div>
        <div className="LandingPageContentMid">
          <FileExplorer fileObject={blobObject} />
        </div>
        <div className="LandingPageContentBottom"></div>
      </div>
    </div>
  </div>
  )
}

export default Remit